import { useEffect } from "react";

import socialImages from "../data/socialImages.json";

const SITE_URL = "https://mrresurface.com";

function setMeta(selector, attr, name, content) {
  let tag = document.querySelector(selector);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute(attr, name);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content || "");
}

export default function useSeo(title, description, options = {}) {
  useEffect(() => {
    if (title) document.title = title;
    setMeta('meta[name="description"]', "name", "description", description);

    const path = window.location.pathname.replace(/\/+$/, "") || "/";
    const canonical = options.canonical || `${SITE_URL}${path === "/" ? "/" : path}`;
    let link = document.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", canonical);

    setMeta('meta[property="og:title"]', "property", "og:title", title);
    setMeta('meta[property="og:description"]', "property", "og:description", description);
    setMeta('meta[property="og:url"]', "property", "og:url", canonical);
    setMeta('meta[property="og:type"]', "property", "og:type", "website");
    setMeta('meta[name="twitter:card"]', "name", "twitter:card", "summary_large_image");
    setMeta('meta[name="twitter:title"]', "name", "twitter:title", title);
    setMeta('meta[name="twitter:description"]', "name", "twitter:description", description);

    const card = SITE_URL + (socialImages.images[path] || socialImages.images.default);
    const cardAlt = socialImages.alts[path] || socialImages.alts.default;
    setMeta('meta[property="og:image"]', "property", "og:image", card);
    setMeta('meta[property="og:image:secure_url"]', "property", "og:image:secure_url", card);
    setMeta('meta[property="og:image:width"]', "property", "og:image:width", "1200");
    setMeta('meta[property="og:image:height"]', "property", "og:image:height", "630");
    setMeta('meta[name="twitter:image"]', "name", "twitter:image", card);
    setMeta('meta[property="og:image:alt"]', "property", "og:image:alt", cardAlt);
    setMeta('meta[name="twitter:image:alt"]', "name", "twitter:image:alt", cardAlt);

    let robots = document.querySelector('meta[name="robots"]');
    const value = options.noindex ? "noindex, nofollow" : "index, follow";
    if (!robots) {
      robots = document.createElement("meta");
      robots.setAttribute("name", "robots");
      document.head.appendChild(robots);
    }
    robots.setAttribute("content", value);
  }, [title, description, options.canonical, options.noindex]);
}
